import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useEffect } from 'react';

export default function Services() {
  useEffect(() => {
    // Set page title and meta description
    document.title = '事業内容｜不動産売買・買取・査定サービス｜おかやま不動産販売株式会社';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '岡山市の不動産売買、買取、査定サービスのご案内。戸建て、マンション、土地の売却から購入まで、24年の実績でお客様をサポートいたします。');
    }

    // Add structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Service",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services#service`,
          "serviceType": "不動産売買・買取サービス",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "おかやま不動産販売株式会社",
            "url": import.meta.env.VITE_SITE_URL || 'https://example.com'
          },
          "areaServed": {
            "@type": "City",
            "name": "岡山市"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "不動産サービス",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "不動産売買仲介",
                  "description": "お客様の大切な不動産の売却・購入をサポート"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "不動産買取",
                  "description": "最短1週間での現金化が可能"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "無料査定",
                  "description": "専門スタッフによる適正価格の査定"
                }
              }
            ]
          }
        },
        {
          "@type": "WebPage",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services#webpage`,
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`,
          "name": "事業内容｜おかやま不動産販売株式会社",
          "description": "岡山市の不動産売買、買取、査定サービスのご案内",
          "isPartOf": {
            "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`
          }
        }
      ]
    };

    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const services = [
    {
      title: '不動産売買仲介',
      description: '戸建て・マンション・土地の売買仲介を専門に行っております。',
      features: [
        '市場価格調査・査定',
        '販売戦略の立案',
        '購入希望者の紹介',
        '契約手続きサポート',
        '住宅ローン相談',
        'アフターフォロー'
      ],
      image: 'https://public.readdy.ai/ai/img_res/928e8e209ae9a47dd5f22880b99cd332.jpg'
    },
    {
      title: '不動産買取',
      description: '迅速な現金化をご希望の方に最適な買取サービスです。',
      features: [
        '最短1週間での現金化',
        '仲介手数料不要',
        '現状のまま買取可能',
        'リフォーム費用不要',
        '秘密厳守での取引',
        '相続物件も対応'
      ],
      image: 'https://readdy.ai/api/search-image?query=Japanese%20businessman%20in%20suit%20holding%20cash%20and%20house%20keys%2C%20professional%20real%20estate%20transaction%20scene%2C%20modern%20office%20background%2C%20quick%20property%20sale%20concept%2C%20trustworthy%20business%20atmosphere&width=600&height=400&seq=service-detail2&orientation=landscape'
    },
    {
      title: '無料査定サービス',
      description: '専門スタッフによる正確な不動産査定を無料で実施いたします。',
      features: [
        '現地調査による詳細査定',
        '市場動向を反映した価格設定',
        '査定書面の提出',
        '売却時期のアドバイス',
        '税務相談',
        '相続対策のご提案'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20real%20estate%20appraiser%20with%20tablet%20and%20measuring%20tools%20evaluating%20property%2C%20modern%20house%20interior%2C%20detailed%20inspection%20process%2C%20accurate%20assessment%20work&width=600&height=400&seq=service-detail3&orientation=landscape'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'お問い合わせ',
      description: 'お電話またはメールフォームからお気軽にご相談ください。'
    },
    {
      step: '02',
      title: 'ヒアリング',
      description: 'お客様のご要望や物件の詳細について詳しくお聞きします。'
    },
    {
      step: '03',
      title: '査定・調査',
      description: '専門スタッフが現地調査を行い、適正価格を算出いたします。'
    },
    {
      step: '04',
      title: 'ご提案',
      description: '査定結果と最適な売却プランをご提案いたします。'
    },
    {
      step: '05',
      title: '契約・取引',
      description: '契約手続きから決済まで、安心してお任せください。'
    }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">事業内容</h1>
              <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
                岡山市を中心とした不動産売買・買取のプロフェッショナルサービス
              </p>
            </div>
          </div>
        </section>

        {/* Services Detail */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-20">
              {services.map((service, index) => (
                <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                  <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                    <h2 className="text-3xl font-bold text-gray-900 mb-6">{service.title}</h2>
                    <p className="text-lg text-gray-600 mb-8 leading-relaxed">{service.description}</p>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {service.features.map((feature, featureIndex) => (
                        <div key={featureIndex} className="flex items-center">
                          <i className="ri-check-line text-blue-600 mr-3"></i>
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-80 object-cover object-top rounded-xl shadow-lg"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                ご利用の流れ
              </h2>
              <p className="text-xl text-gray-600">
                お問い合わせから取引完了まで、安心のサポート体制
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
              {process.map((item, index) => (
                <div key={index} className="relative text-center">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                    {item.step}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
                  
                  {index < process.length - 1 && (
                    <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-blue-200 z-0" style={{ transform: 'translateX(50%)' }}></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              不動産のことなら、お気軽にご相談ください
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              経験豊富なスタッフが、お客様のご要望に合わせて最適なプランをご提案いたします
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:086-012-3456"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                メールで相談
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
